import { render, staticRenderFns } from "./RsaGestioneAssistitiListComponent.vue?vue&type=template&id=a6d161e0"
import script from "./RsaGestioneAssistitiListComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneAssistitiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports